/**
 * This module is responsible for handling the app-specific functions.
 */


import { apiRequest, SAVE_BLOG, FETCH_BLOGS, FETCH_BLOG, CREATE_USER, FETCH_CATEGORIES, FETCH_LANGUAGES, FETCH_ROLES, apiRequestSaveBlog, UPDATE_BLOG, FETCH_USERS, TRANSLATE_TEXT, FETCH_STATICS, UPDATE_STATICS, FETCH_DEVICES, UPDATE_DEVICE, REQUEST_REGISTER, FETCH_ATTENDANCE, RECORD_ATTENDANCE, CUSTOM_MIDDLE_REQUEST } from "../actions/api";
import { LOGIN, RESET_PASSWORD } from "../actions/auth";

const SERVER_URL = getUrl();

export { SERVER_URL };
export const appMiddleware = ({ getState: _getState }) => next => action => {
  next(action);
  const getState = () => _getState().reducer;
  const getAuthtoken = () => getState().user.token;
  switch (action.type) {
    case CUSTOM_MIDDLE_REQUEST:
      const { url, method, data, requestedBy, params } = action.payload;
      const tos = {
        requestedBy,
        type: "API_REQUEST",
        meta: { url: `${SERVER_URL}/${url}`, method, data, headers:{ Authorization: getAuthtoken() }, params },
        CUSTOM_MIDDLE: true
      };
      next(tos);
      break;
    case LOGIN: {
      let tos = {
        url: `${SERVER_URL}/login`,
        method: "POST",
        data: {
          username: action.payload.email,
          password: action.payload.password,
          login_type: "FRESH"
        },
        requestFor: LOGIN
      };
      next(
        apiRequest(tos)
      );
      break;
    }
    case RESET_PASSWORD: {
      const currentState = getState();
      const session = currentState.user.session;
      let tos = {
        url: `${SERVER_URL}/resetPassword`,
        method: "POST",
        data: {
          username: action.payload.email,
          password: action.payload.newPassword,
          session,
          login_type: "NEW_PASSWORD_REQUIRED"
        },
        requestFor: LOGIN
      };
      next(
        apiRequest(tos)
      );
      break;
    }
    case SAVE_BLOG: {
      let tos = {
        getPresignedUrl: `${SERVER_URL}/getPresignedUploadUrl`,
        saveBlogUrl: `${SERVER_URL}/saveBlog`,
        // data: {
        //   title: action.payload.title,
        //   description: action.payload.description,
        //   featuredImage:action.payload.featuredImage
        // },
        data: action.payload,
        headers: { Authorization: getAuthtoken() }
      };
      next(
        apiRequestSaveBlog(tos)
      );
      break;
    }

    case FETCH_BLOGS: {
      let tos = {
        url: `${SERVER_URL}/getBlogsAdmin`,
        method: "GET",
        headers: { Authorization: getAuthtoken() },
        requestFor: FETCH_BLOGS
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case FETCH_BLOG: {
      // console.log(action);
      let tos = {
        url: `${SERVER_URL}/getBlogsAdmin?blog_id=${action.payload.blog_id}`,
        method: "GET",
        headers: { Authorization: getAuthtoken() },
        params: action.payload,
        requestFor: FETCH_BLOG
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case TRANSLATE_TEXT: {
      console.log(action);
      let tos = {
        url: `${SERVER_URL}/translateText`,
        method: "POST",
        headers: { Authorization: getAuthtoken() },
        data: {
          ...action.payload
        }
        ,
        requestFor: TRANSLATE_TEXT
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case FETCH_USERS: {
      let tos = {
        url: `${SERVER_URL}/getUsers`,
        method: "GET",
        headers: { Authorization: getAuthtoken() },
        requestFor: FETCH_USERS
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case FETCH_CATEGORIES: {
      let tos = {
        url: `${SERVER_URL}/getData?purpose=category`,
        method: "GET",
        headers: { Authorization: getAuthtoken() },
        requestFor: FETCH_CATEGORIES
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case FETCH_LANGUAGES: {
      let tos = {
        url: `${SERVER_URL}/getData?purpose=language`,
        method: "GET",
        headers: { Authorization: getAuthtoken() },
        requestFor: FETCH_LANGUAGES
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case FETCH_ROLES: {
      let tos = {
        url: `${SERVER_URL}/getData?purpose=roles`,
        method: "GET",
        headers: { Authorization: getAuthtoken() },
        requestFor: FETCH_ROLES
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case FETCH_DEVICES: {
      let tos = {
        url: `${SERVER_URL}/listDevices`,
        method: "GET",
        headers: { Authorization: getAuthtoken() },
        requestFor: FETCH_DEVICES
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case UPDATE_DEVICE: {
      let tos = {
        url: `${SERVER_URL}/updateDevice`,
        method: "POST",
        data: action.payload,
        headers: { Authorization: getAuthtoken() },
        requestFor: UPDATE_DEVICE
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case REQUEST_REGISTER: {
      let tos = {
        url: `${SERVER_URL}/registerDevice`,
        method: "POST",
        data: action.payload,
        headers: { Authorization: getAuthtoken() },
        requestFor: REQUEST_REGISTER
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case FETCH_ATTENDANCE: {
      let tos = {
        url: `${SERVER_URL}/fetchAttendance`,
        method: "GET",
        data: action.payload,
        headers: { Authorization: getAuthtoken() },
        requestFor: FETCH_ATTENDANCE
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case RECORD_ATTENDANCE: {
      let tos = {
        url: `${SERVER_URL}/recordAttendance`,
        method: "POST",
        data: action.payload,
        headers: { Authorization: getAuthtoken() },
        requestFor: RECORD_ATTENDANCE
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case FETCH_STATICS: {
      let tos = {
        url: `${SERVER_URL}/getData?purpose=statics`,
        method: "GET",
        headers: { Authorization: getAuthtoken() },
        requestFor: FETCH_STATICS
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case UPDATE_STATICS: {
      let tos = {
        url: `${SERVER_URL}/updateStatics`,
        method: "POST",
        data: action.payload,
        headers: { Authorization: getAuthtoken() },
        requestFor: UPDATE_STATICS
      };
      // fetch(tos.url, tos).then(res => {
      //   console.log(res);
      // })
      next(
        apiRequest(tos)
      );
      break;
    }

    case CREATE_USER: {
      let tos = {
        url: `${SERVER_URL}/createUser`,
        method: "POST",
        data: {
          ...action.payload,
        },
        headers: { Authorization: getAuthtoken() }
      };
      next(
        apiRequest(tos)
      );
      break;
    }

    case UPDATE_BLOG: {
      let tos = {
        url: `${SERVER_URL}/updateBlog`,
        method: "POST",
        data: action.payload,
        headers: { Authorization: getAuthtoken() },
        requestFor: UPDATE_BLOG
      };
      // fetch(tos.url, tos).then(res => {
      //   console.log(res);
      // })
      next(
        apiRequest(tos)
      );
      break;
    }

    default:
      break;
  }
};

function getUrl() {
  // const env = process.env.NODE_ENV;
  const env = 'production';
  // const domain = "https://q66tih4to4.execute-api.ap-south-1.amazonaws.com";
  const domain = "https://062cc2hnef.execute-api.ap-south-1.amazonaws.com";
  if (env === 'development')
    return `${domain}/TEST`;
  else if (env === 'production')
    return `${domain}/PROD`;
} 